<template>
<q-list dense separator>

    <q-item v-if="item.label">
        <q-item-section avatar class="normal">Label</q-item-section>
        <q-item-section class="break-word">
            <q-item-label>{{ item.label }}</q-item-label>
        </q-item-section>
    </q-item>

    <q-item v-for="(el, k) in list" :key="k"
            v-show="! $_.isNull(item[el.column])">

        <q-item-section avatar class="normal">
            <q-item-label caption><span v-html="el.label"></span></q-item-label>
        </q-item-section>
        <q-item-section>
            <q-item-label caption v-if="! (/_at/).test(el.column)" :class="'q-ml-sm'+((/status/).test(el.column) ? ' text-'+colisStore().getStatusColor(item.status) : '')">
                <b>{{ el.value }}</b>

                <Popup v-if="el.column == 'creator_id' && props.item.creator?.shop" dense padding="none" class="q-ml-sm">
                    <InfosUserShop :shop="props.item.creator.shop" />
                </Popup>
                <Popup v-if="el.column == 'driver_id' && props.item.driver" dense padding="none" class="q-ml-sm">
                    <InfosDriver :driver="props.item.driver" />
                </Popup>
            </q-item-label>
            <q-item-label v-else caption class="q-ml-sm">
                <q-badge color="blue-8">{{ el.value }}</q-badge>
            </q-item-label>
        </q-item-section>
    </q-item>


    <!-- <ButtonsHandleStatus :item="item" v-if=" ! withoutHandleStatus" /> -->

</q-list>

</template>

<script setup>
import { formatDate } from "@helpers";
import { colisStore } from '@stores'

import InfosUserShop from '@page/Users/partials/InfosUserShop.vue'
import InfosDriver from '@page/Users/partials/InfosDriver.vue'
// import ButtonsHandleStatus from "./ButtonsHandleStatus.vue";

const props = defineProps({
    item: Object,
    // 'without-handle-status': Boolean, // ex: in Course/partials/ExpandIndex.vue
})

// log('in ListStatus.vue', props.item)

let list = [
    {label: 'Créée le',     column: 'created_at',   value: formatDate({datetime: props.item.created_at, withHour: true}) },
    {label: 'Créée par',    column: 'creator_id',   value: props.item.creator?.name },
    {label: 'Validée le',   column: 'validated_at', value: formatDate({datetime: props.item.validated_at, withHour: true}) },
    {label: 'Validée par',  column: 'validate_by',  value: props.item.validator?.name },

    {label: 'Chauffeur',                    column: 'driver_id',    value: props.item.driver?.name },
    {label: 'Chauffeur<br/>Attribué par',   column: 'drivered_by',  value: props.item.driveror?.name },
]


</script>
